import React from "react";
import { Card, Row, Col, ListGroup } from "react-bootstrap";
import "react-bootstrap-icons";
import { HandThumbsUp } from "react-bootstrap-icons";

function AccountHealth({ InsuranceDetails }) {
  return (
    <div>
      <Card
        style={{
          border: "1px solid #ddd",
          borderRadius: "2px",
          // backgroundColor: "white",
          marginLeft: "5px",
        }}
        className="ml-2 border border-primary p-2 h-100"
      >
        <Card.Header style={{ fontWeight: "bold" }}>
          Insurance Details
        </Card.Header>
        <Card.Body style={{ padding: "0.5rem", backgroundColor: "white" }}>
          <Row>
            <Col>
              <ListGroup className="list-group-no-border">
                <ListGroup.Item style={{ border: "none" }} className="p-3">
                  <strong>Description</strong>
                </ListGroup.Item>
              </ListGroup>
            </Col>
            <Col>
              <ListGroup className="list-group-no-border">
                <ListGroup.Item style={{ border: "none" }} className="p-3">
                  : {InsuranceDetails?.[0]?.description || " - "}
                </ListGroup.Item>
              </ListGroup>
            </Col>
          </Row>
          <Row>
            <Col>
              <ListGroup className="list-group-no-border">
                <ListGroup.Item style={{ border: "none" }} className="p-3">
                  <strong>Company Name</strong>
                </ListGroup.Item>
              </ListGroup>
            </Col>
            <Col>
              <ListGroup className="list-group-no-border">
                <ListGroup.Item style={{ border: "none" }} className="p-3">
                  : {InsuranceDetails?.[0]?.company_name || " - "}
                </ListGroup.Item>
              </ListGroup>
            </Col>
          </Row>
          <Row>
            <Col>
              <ListGroup className="list-group-no-border">
                <ListGroup.Item
                  style={{ padding: "0", border: "none" }}
                  className="p-3"
                >
                  <strong>Policy Number</strong>
                </ListGroup.Item>
              </ListGroup>
            </Col>
            <Col>
              <ListGroup className="list-group-no-border">
                <ListGroup.Item
                  style={{ padding: "0", border: "none" }}
                  className="p-3"
                >
                  : {InsuranceDetails?.[0]?.policy_number || " - "}
                </ListGroup.Item>
              </ListGroup>
            </Col>
          </Row>
          <Row>
            <Col>
              <ListGroup className="list-group-no-border">
                <ListGroup.Item
                  style={{ padding: "0", border: "none" }}
                  className="p-3"
                >
                  <strong>Expiry Date</strong>
                </ListGroup.Item>
              </ListGroup>
            </Col>
            <Col>
              <ListGroup className="list-group-no-border">
                <ListGroup.Item
                  style={{ padding: "0", border: "none" }}
                  className="p-3"
                >
                  : {InsuranceDetails?.[0]?.expiry_date || " - "}
                </ListGroup.Item>
              </ListGroup>
            </Col>
          </Row>
          <Row>
            <Col>
              <ListGroup className="list-group-no-border">
                <ListGroup.Item
                  style={{ padding: "0", border: "none" }}
                  className="p-3"
                >
                  <strong>Coverage</strong>
                </ListGroup.Item>
              </ListGroup>
            </Col>
            <Col>
              <ListGroup className="list-group-no-border">
                <ListGroup.Item
                  style={{ padding: "0", border: "none" }}
                  className="p-3"
                >
                  : {InsuranceDetails?.[0]?.coverage || " - "}
                </ListGroup.Item>
              </ListGroup>
            </Col>
          </Row>
        </Card.Body>

        <Row>
          <Col>
            <div className="d-flex justify-content-center"></div>
          </Col>
        </Row>
      </Card>
    </div>
  );
}

export default AccountHealth;
